export default "__VITE_ASSET__BNt_tKn1__"